module.exports = __webpack_public_path__ + "static/feature_image.07aa8116.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/feature_image.png
// module id = 710
// module chunks = 154382131621592